// Little snippets to ensure the popup work as spec.
// They still work without Javascript, as the `group-hover:` variant should be able
// to show them, but we want the `open` attribute to be there.
const popups = document.querySelectorAll(`.gallery .group dialog[class*="group-hover\:"]`);
popups.forEach((/** @type {HTMLDialogElement} **/ dialog) => {
  const group = dialog.closest(".group");
  group.addEventListener("mouseenter", () => {
    dialog.show();
  });
  group.addEventListener("mouseleave", () => {
    dialog.close();
  });
});
